import CarDetails from '@common/pages/Dashboard/components/CarDetails';
import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import theme from '../../../../theme';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { useLazyGetBidHistoryQuery } from '../../../../toolkit/liveAuction/liveAuctionApi';
import SaleInformation from '../SaleInformation';
import { mainContainer } from '../VehicleInfoSidebarSx';
// import { useLiveAuctionSocketEvents } from "./customHooks/useLiveAuctionSocketEvents";
import { parsedVehicle } from '@common/utils/methods/parsedVehicleForCarData';
import { useLocation } from 'react-router-dom';
import { reducerPaths } from '../../../../app/reducerPaths';
import { useCountdownTimer } from '../../../../customHooks/useCountdownTimer';
import { useLazyGetBuyNowTimeoutDetailsQuery } from '../../../../toolkit/buyNow/buyNowApi';
import { useLazyGetAgentDetailsQuery } from '../../../../toolkit/carDetails/carDetailsApi';
import { useLazyGetVehicleQuery } from '../../../../toolkit/vehicle/vehicleApi';
import { Bidding_Through } from '../../../../utils/constants/auction';
import { routes } from '../../../../utils/constants/routes';
// import { useBuyNowSocketEvents } from "./customHooks/useBuyNowAuctionSocketEvents";
import { useTranslation } from 'react-i18next';
import { resetLiveAuctionSlice } from "../../../../toolkit/liveAuction/liveAuctionSlice";
import { getCommaFormattedPrice } from '../../../../utils/methods/stringMethods';
import TimeLeft from '../../components/TimeLeft';
import CarDetailSkeleton from '../CarDetailsSkeleton';
import CostBreakdownSeller from '../../../../components/custom/CostBreakdownSection/CostBreakdownSeller';

// const TimeLeftInBuyNow = ({
//   data
// }) => {
//   const { t } = useTranslation("buyNowCarDetailReadOnly");
//   const { countDown, isInitialised } = useCountdownTimer({
//     seconds: Math.floor(data?.seconds || 0)
//   });

//   console.log(`formatTimeFromSeconds`, data);

//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         border: `2px solid ${theme.palette.primary.main}`,
//         textAlign: "center",
//         borderRadius: "0.75rem", // 12px
//         paddingTop: "1rem",      // 16px
//         paddingBottom: "1rem",
//         paddingLeft: "0.5rem",   // 8px
//         paddingRight: "0.5rem",
//       }}
//     >
//       {(countDown?.hours > 0 || countDown?.minutes > 0 || countDown?.seconds > 0) && isInitialised ? <Typography fontWeight={600} fontSize="1.1rem"
//         sx={{
//           color: theme.palette.primary.main
//         }}
//       >
//         {t("Time Left In Buy Now")}
//       </Typography> : null}
//       <Typography fontWeight={500} fontSize="1rem" marginTop="0.25rem"
//         sx={{
//           color: theme.palette.primary.main
//         }}
//       >
//         {!isInitialised ? (
//           <span style={{ fontWeight: 700, color: theme.palette.primary.main }}>
//             Loading...
//           </span>
//         ) : countDown?.hours > 0 || countDown?.minutes > 0 || countDown?.seconds > 0 ? (
//           <>
//             <span style={{ fontWeight: 800, color: theme.palette.primary.main }}>
//               {`${countDown?.hours < 10 ? `0${countDown?.hours}` : countDown?.hours}`}
//             </span>{" "}{t("hours")}{" "}
//             <span style={{ fontWeight: 800, color: theme.palette.primary.main }}>
//               {`${countDown?.minutes < 10 ? `0${countDown?.minutes}` : countDown?.minutes}`}
//             </span>{" "}{t("mins")}{" "}
//             <span style={{ fontWeight: 800, color: theme.palette.primary.main }}>
//               {`${countDown?.seconds < 10 ? `0${countDown?.seconds}` : countDown?.seconds}`}
//             </span>{" "}{t("sec")}
//           </>
//         ) : (
//           <span style={{ fontWeight: 700, color: theme.palette.primary.main }}>
//             {t("Time's up")}
//           </span>
//         )}

//       </Typography>
//     </Box>
//   );
// };

const CurrentHighestOffer = ({ highestBid }) => {
  const { t } = useTranslation('buyNowCarDetailReadOnly');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.red,
        borderRadius: '1.4rem',
        padding: '1.5rem',
        boxShadow: '0 0.25rem 0.5rem rgba(0, 0, 0, 0.1)', // Example shadow
      }}
    >
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          color: theme.palette.text.secondary, // White text as per screenshot
          padding: '0.75rem',
          borderRadius: '0.5rem', // Rounded corners for the price box
          fontWeight: '700',
        }}
      >
        {t('Current highest offer')}
      </Typography>

      <Typography
        variant="body2" // Using h4 as it seems appropriate for the size in the screenshot
        sx={{
          color: theme.palette.text.secondary, // White text as per screenshot
          padding: '0.75rem',
          borderRadius: '0.5rem', // Rounded corners for the price box
          fontSize: '2.5rem',
          fontWeight: '700',
          textAlign: "center",
        }}
      >
        {highestBid?.Bid_Amount ? `$${getCommaFormattedPrice(highestBid?.Bid_Amount)}` : t('No offers yet')}
      </Typography>
    </Box>
  );
};

const CarSoldTag = ({ soldPrice }) => {
  const { t } = useTranslation('buyNowCarDetailReadOnly');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        padding: '1.5rem', // Overall padding around the content
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: '1.25rem', // Rounded corners for the main card
          padding: '1.5rem', // Inner padding for the main card
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem', // Space between the two inner boxes
          width: '100%', // Take full width of parent
          maxWidth: '25rem', // Max width for desktop view
          boxShadow: '0rem 0.25rem 0.625rem rgba(0, 0, 0, 0.1)', // Subtle shadow
        }}
      >
        {/* Car Sold Section */}
        <Box
          sx={{
            backgroundColor: 'rgba(43, 210, 76, 0.1)', // Light green background (10% opacity of primary.green)
            border: `0.0625rem solid ${theme.palette.primary.green}`, // Green border
            borderRadius: '0.625rem', // Rounded corners
            paddingTop: '1.5rem',
            paddingBottom: '1.5rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body1" // Use body1 variant for text
            sx={{
              color: theme.palette.primary.green, // Green text color
              fontWeight: 600, // Make text bold
              fontSize: '1.125rem', // Custom font size for this text
            }}
          >
            {t('Car Sold')}
          </Typography>
        </Box>

        {/* Sold Price Section */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.green, // Darker green background
            borderRadius: '0.625rem', // Rounded corners
            paddingTop: '1.5rem',
            paddingBottom: '1.5rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="body1" // Use body1 for "Sold Price"
            sx={{
              color: theme.palette.text.secondary, // White text
              fontWeight: 500,
              fontSize: '1rem',
              marginBottom: '0.5rem', // Space below "Sold Price"
            }}
          >
            {t('Sold Price')}
          </Typography>
          <Typography
            variant="h6" // Using h6 for the price to make it larger and bolder
            sx={{
              color: theme.palette.text.secondary, // White text
              fontWeight: 700, // Extra bold for the price
              fontSize: '1.75rem', // Larger font size for the price
            }}
          >
            {`$${getCommaFormattedPrice(soldPrice)}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

// Main Car Detail Page component
const BuyNowCarDetailReadOnly = ({
  useBuyNowSocketEvents,
  // selectedCar,
  // setSelectedCar
}) => {
  const { t } = useTranslation('buyNow');
  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.buyNow}/`)?.[1];

  const isMobile = useMediaQuery('(max-width:1300px)');

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const liveAuction = useSelector((store) => store[reducerPaths.liveAuction]);
  const buyNow = useSelector((store) => store[reducerPaths.buyNow]);
  const auth = useSelector((store) => store[reducerPaths.auth]);
  // useSelector end...

  // useState variables start...
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [buyNowRemainingSeconds, setBuyNowRemainingSeconds] = React.useState(0);
  const [isVehicleSold, setIsVehicleSold] = React.useState(false);
  // useState variables end...

  // Handlers start...
  const onNewBidHandler = async () => {
    await getBidHistoryApiHandler({
      vehicleId: selectedCar?.Vehicle_Id,
    });
  };
  // Handlers end...

  // custom hooks start...
  const [getBidHistoryApiHandler, getBidHistoryApiData] = useLazyGetBidHistoryQuery();
  const [getVehicleApiHandler, getVehicleApiData] = useLazyGetVehicleQuery();
  const [getAgentDetailsApiHandler, getAgentDetailsApiData] = useLazyGetAgentDetailsQuery();
  const [getBuyNowTimeoutDetailsApiHandler, getBuyNowTimeoutDetailsApiData] = useLazyGetBuyNowTimeoutDetailsQuery();

  useBuyNowSocketEvents({
    Vehicle_Id: selectedCar?.Vehicle_Id,
    onNewBidHandler,
  });

  const { countDown } = useCountdownTimer({
    seconds: buyNowRemainingSeconds,
  });
  // custom hooks end...

  // useEffect start...
  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }

    (async () => {
      const res = await getBidHistoryApiHandler({
        vehicleId: selectedCar?.Vehicle_Id,
      });

      if (res?.error) {
        dispatch(
          setAlertDialog({
            open: true,
            title: t('Error!'),
            message: res?.error?.data?.message || res?.error?.data?.error || t('Some error occured!'),
          })
        );
      }

      console.log(res, `getBidHistoryApiHandler`);
    })();
  }, [selectedCar?.Vehicle_Id]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getVehicleApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: t('Error'),
              message: res?.error?.data?.error || res?.error?.data?.message || t('Some error occured!'),
            })
          );
        } else {
          setSelectedCar(res?.data?.vehicle);
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getAgentDetailsApiHandler({
          vehicleId: Vehicle_Id,
        });

        console.log(res, `getAgentDetailsApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: t('Error'),
              message: res?.error?.data?.error || res?.error?.data?.message || t('Some error occured!'),
            })
          );
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getBuyNowTimeoutDetailsApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getBuyNowTimeoutDetailsApiHandler`);

        if (res?.error || ('status' in (res?.data || {}) && !res?.data?.status)) {
          dispatch(
            setAlertDialog({
              open: true,
              title: t('Error'),
              message:
                res?.error?.data?.error || res?.error?.data?.message || res?.data?.message || t('Some error occured!'),
            })
          );
        } else {
          setBuyNowRemainingSeconds(res?.data?.counterseconds || 0);
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (parseInt(getBidHistoryApiData?.data?.TopBids?.[0]?.Bid_Amount) >= parseInt(selectedCar?.Reserve_Price)) {
      setIsVehicleSold(true);
      // if (getBidHistoryApiData?.data?.TopBids?.[0]?.Dealer_Id !== auth?.user_id) {
      //   dispatch(
      //     setAlertDialog({
      //       open: true,
      //       title: `Info!`,
      //       message: `The car has been sold to dealer id: ${getBidHistoryApiData?.data?.TopBids?.[0]?.Dealer_Id}`,
      //       onClose: () => {
      //         navigate(routes.dashboardNavigation);
      //       }
      //     })
      //   )
      // }
    }
  }, [getBidHistoryApiData?.data?.TopBids]);

  React.useEffect(() => {
    return () => {
      dispatch(resetLiveAuctionSlice());
    };
  }, []);
  // useEffect end...

  console.log(countDown, 'LiveAuctionDetail');

  return (
    <Grid container spacing={2} sx={mainContainer}>
      {getVehicleApiData?.isFetching ? (
        <CarDetailSkeleton />
      ) : (
        <>
          {/* Left sidebar with buttons */}
          <Grid size={{ xl: 2.8 - 0.2, lg: 4 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <Box display={'flex'} flexDirection="column" gap={2}>
              {/* <TimeLeftInBuyNow /> */}
              <TimeLeft
                data={{
                  seconds: buyNowRemainingSeconds,
                }}
              />

              {isVehicleSold ? (
                <CarSoldTag soldPrice={parseInt(getBidHistoryApiData?.data?.TopBids?.[0]?.Bid_Amount)} />
              ) : null}

              <CurrentHighestOffer
                highestBid={
                  getBidHistoryApiData?.data?.TopBids?.filter?.((bid) => {
                    return bid?.Bidding_Through === Bidding_Through.BuyNow;
                  })?.[0]
                }
              />

              <CostBreakdownSeller 
                car={selectedCar}
              />

              <SaleInformation
                data={{
                  ...(getAgentDetailsApiData?.data?.[0] || {}),
                  address: selectedCar?.Location,
                  date: selectedCar?.Live_Auction_DateTime,
                }}
                car={selectedCar}
              />
            </Box>
          </Grid>
          <Divider orientation={'vertical'} flexItem />
          <Grid size={{ xl: 9.2 - 0.2, lg: 8 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <CarDetails car={parsedVehicle(selectedCar)} showEdit />
          </Grid>
          {/* Main content area */}
        </>
      )}
    </Grid>
  );
};

export default BuyNowCarDetailReadOnly;
